module.exports = __webpack_public_path__ + "static/media/female-final.0449267a.svg";